import { Component, computed, inject, signal } from '@angular/core';
import { ParameterService, PaymentService } from '../../provider';

declare const amazon: any;

@Component({
  selector: 'lib-frontend-amazonpay-checkout',
  templateUrl: './amazonpay-checkout.html',
  standalone: true,
  styles: '#AmazonPayButton { margin: 0 auto; }'
})
export class AmazonpayCheckout {
  loading = signal(false);
  private paymentService = inject(PaymentService);
  public parameterService = inject(ParameterService);
  url = signal<string | undefined>('');
  data: any = {};
  public backUrl = computed(() => this.parameterService.getOverviewUrl());

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading.set(true);
    this.paymentService
      .getAmazonCheckout(
        this.parameterService.queryParams.channel_id,
        this.parameterService.queryParams.payment_id ?? '',
        this.parameterService.getAllQueryParameterWithOrigin()
      )
      .subscribe((val) => {
        this.data = val.data;
        this.loadAmazonCheckoutScript();
      });
  }

  loadAmazonCheckoutScript() {
    const myScriptElement = document.createElement('script');
    myScriptElement.src = 'https://static-eu.payments-amazon.com/checkout.js';
    myScriptElement.type = 'text/javascript';
    myScriptElement.async = true;

    myScriptElement.onload = () => {
      this.initAmazonPayButton();
    };

    document.body.appendChild(myScriptElement);
  }

  private getCheckoutSessionConfig() {
    return {
      payloadJSON: this.data.payload.replaceAll('\\/', '/'),
      signature: this.data.signature,
      algorithm: this.data.algorithm,
    };
  }

  private getButtonContent() {
    return {
      // set checkout environment
      merchantId: this.data.merchantId,
      publicKeyId: this.data.publicKeyId,
      ledgerCurrency: 'EUR',
      // customize the buyer experience
      checkoutLanguage: 'de_DE',
      productType: 'PayOnly',
      placement: 'Checkout',
      buttonColor: 'Gold',
      estimatedOrderAmount: {
        amount: this.parameterService.getOpenAmount(),
        currencyCode: 'EUR',
      },
      // configure Create Checkout Session request
      createCheckoutSessionConfig: this.getCheckoutSessionConfig(),
    };
  }

  private initAmazonPayButton() {
    amazon.Pay.renderButton('#AmazonPayButton', this.getButtonContent());
  }
}
